module.exports = __webpack_public_path__ + "img/corona.43786aa2.png";